<template>
    <div class="table">
        <div class="container">
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="form.deptId" placeholder="请选择学校">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
             
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.taskTitle" placeholder="任务标题"></el-input>
                </div>
            </div> 
            &nbsp;
            <el-button type="primary" icon="search" @click="getData()">查询</el-button>
            <div style="display: inline-block; height:40px;float: right;">
                <el-button type="primary"  class="handle-del mr10" icon="el-icon-plus" @click="setAdd()">新增</el-button>
            </div>
            
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="roleId"
                v-loading="loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                element-loading-text = "数据正在加载中..."
                border
                default-expand-all>
                <el-table-column type="index" label="序号" fixed width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="taskTitle" label="任务标题" width="180" :show-overflow-tooltip="true"></el-table-column>
                <!-- <el-table-column prop="name" label="绑定考勤组" width="100" :show-overflow-tooltip="true"></el-table-column> -->
                <el-table-column prop="" label="任务周期" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.cycleType == 1">
                            每月
                        </div>
                        <div v-else-if="scope.row.cycleType == 2">
                            每周
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="任务提醒" width="180">
                    <template slot-scope="scope">
                        <div v-if="scope.row.remindDays != null && scope.row.remindDays != ''">
                            <span>{{formatRemindDays(scope.row)}}</span>
                            <span v-if="scope.row.remindTime" style="color:#409EFF;margin-left:4px;">{{scope.row.remindTime}}</span>
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="commonName" label="生成任务关联模块" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="receiveUserName" label="任务接收者" :show-overflow-tooltip="true" width="150"></el-table-column>
                <el-table-column prop="executeCount" label="执行次数" width="80"></el-table-column>
                <el-table-column prop="status" label="状态" width="80">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1">启动</span>
                        <span v-else-if="scope.row.status == 2" style="color:red;">停用</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="100px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button  @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>
                        <el-button style="color: red" @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 新增/修改弹出框 -->
        <div v-if="addVisible">
            <add ref="add"></add>
        </div>
        <div v-if="updateVisible">
            <update ref="update"></update>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http'; 
    import add from './Add.vue';
    import update from './Update.vue';

    export default {
        name:"TaskConfig",
        data(){
            return{
                loading:false,
                addVisible:false,
                updateVisible:false,
                form:{
                    id:"",
                    deptId:"",
                    taskTitle:""
                },
                data:[],
                depts:[],
            }
        },
        components: {
            add,update
        },
        created:function () {
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (index+1);
            },
            formatRemindDays(row){
                if(!row.remindDays) return '';
                let days = row.remindDays.split(',');
                if(row.cycleType == 1){
                    // 每月：日期补零
                    return days.map(d => { let n = parseInt(d); return n < 10 ? '0' + n : n; }).join(',');
                } else if(row.cycleType == 2){
                    // 每周：数字转星期
                    let weekMap = {1:'周一',2:'周二',3:'周三',4:'周四',5:'周五',6:'周六',7:'周日'};
                    return days.map(d => weekMap[parseInt(d)] || d).join(',');
                }
                return days.join(',');
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                let url  = this.myTaskConfigListUrl;
                let data = {
                    deptId:this.form.deptId,
                    taskTitle:this.form.taskTitle,
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        // console.log(res.data);
                       this.data = res.data;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }
                else{
                    return true;
                }
            },
            //新增界面
            setAdd(){
                this.addVisible=true;
                this.$nextTick(() => {
                    this.$refs['add'].init(this.form.deptId);
                })
            },
            //修改界面
            setUpdate(data){
                this.updateVisible=true;
                this.$nextTick(() => {
                    this.$refs['update'].init(data);
                })
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.myTaskConfigRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/task/TaskConfig.vue